import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import approveAlliance from './approveAlliance';

export default (id, callback) => (dispatch) => {
    const dataAlert = {
        messages: [
            i18next.t(
                'Once the request is approved, the changes can no longer be reverted',
            ),
        ],
        onSuccess: () => dispatch(approveAlliance(id, callback)),
        textToValidate: i18next.t('Delete').toUpperCase(),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };
    dispatch(alerts.actions.show(dataAlert));
};
